import axios from "axios/dist/browser/axios.cjs";

const httpClient = axios.create({
  baseURL: "/api",
  headers: {
    // "Content-Type": "application/json",
    // Accept: "application/json",
  },
  timeout: 30000, // 30 seconds timeout
});

// Request interceptor - add CSRF token to requests
// httpClient.interceptors.request.use(
//   (config) => {
//     // Get CSRF token from meta tag
//     const csrfToken = document
//       .querySelector('meta[name="csrf-token"]')
//       ?.getAttribute("content");

//     if (csrfToken) {
//       config.headers["X-CSRF-Token"] = csrfToken;
//     }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// Response interceptor - standardize responses and handle errors
httpClient.interceptors.response.use(
  (response) => {
    // Standardize successful responses

    if (response.data?.redirect_path) {
      window.location.href = response.data.redirect_path;
    }

    return {
      success: true,
      data: response.data,
      status: response.status,
      statusText: response.statusText,
      headers: response.headers,
    };
  },
  (error) => {
    // Extract error details
    const errorResponse = {
      success: false,
      status: error.response?.status,
      statusText: error.response?.statusText,
      message: error.message,
      data: error.response?.data,
    };

    if (error.response?.status === 401) {
      // Handle unauthorized (e.g., redirect to login)
      console.log("Unauthorized access - redirecting to login");
      // window.location.href = '/user_sessions/new';
    }

    if (error.response?.status === 403) {
      // Handle forbidden
      console.log("Forbidden access");
    }

    if (error.response?.status === 500) {
      // Handle server errors
      console.log("Server error occurred");
    }

    return Promise.reject(errorResponse);
  }
);

// Helper methods for common HTTP operations
export const api = {
  /**
   * GET request
   * @param {string} url - The endpoint to fetch from
   * @param {Object} params - Query parameters
   * @param {Object} config - Additional axios config
   */
  async get(url, params = {}, config = {}) {
    return httpClient.get(url, { ...config, params });
  },

  /**
   * POST request
   * @param {string} url - The endpoint to post to
   * @param {Object} data - The data to post
   * @param {Object} config - Additional axios config
   */
  async post(url, data = {}, config = {}) {
    return httpClient.post(url, data, config);
  },

  /**
   * PUT request
   * @param {string} url - The endpoint to update
   * @param {Object} data - The data to update with
   * @param {Object} config - Additional axios config
   */
  async put(url, data = {}, config = {}) {
    return httpClient.put(url, data, config);
  },

  /**
   * PATCH request
   * @param {string} url - The endpoint to partially update
   * @param {Object} data - The data to update with
   * @param {Object} config - Additional axios config
   */
  async patch(url, data = {}, config = {}) {
    return httpClient.patch(url, data, config);
  },

  /**
   * DELETE request
   * @param {string} url - The endpoint to delete from
   * @param {Object} config - Additional axios config
   */
  async delete(url, config = {}) {
    return httpClient.delete(url, config);
  },
};

export default httpClient;
